module.exports = __webpack_public_path__ + "static/DanBeerman-Resume.a88e19ec.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/DanBeerman-Resume.pdf
// module id = 137
// module chunks = 35783957827783 263791100135453